import type { IPLWidgetControllerCards } from "@swiggy-private/dls-react-mxn/dist/WidgetController/PLWidgetController/type";
import { CROSS_SELL_MENU_DEFAULT_PARENT_TYPE } from "./constants";
import { ItemCard, MenuCategoryCardShape, MenuItemCategoryMeta, WidgetTypes } from "../../types";

const getDishItemId = (item: ItemCard): string | undefined => {
    if (item?.card?.["@type"] !== WidgetTypes.DISH_WIDGET) return undefined;
    const id = (item.card.info as { id?: string | number } | undefined)?.id;
    return id !== undefined && id !== null ? String(id) : undefined;
};

export const findCategoryMetaForMenuItem = (
    cards: IPLWidgetControllerCards[],
    itemId: string
): MenuItemCategoryMeta | null => {
    for (const card of cards) {
        const inner = card?.card?.card as MenuCategoryCardShape | undefined;
        if (!inner || typeof inner["@type"] !== "string") continue;
        const cardType = inner["@type"];

        if (cardType === WidgetTypes.ITEM_CATEGORY_TYPE) {
            if (
                !Array.isArray(inner.itemCards) ||
                !inner.itemCards.some((ic) => getDishItemId(ic) === itemId)
            ) {
                continue;
            }
            return {
                collectionName: String(inner.title ?? ""),
                collectionId: String(inner.categoryId ?? ""),
                parentType: String(inner.parentType ?? CROSS_SELL_MENU_DEFAULT_PARENT_TYPE),
            };
        }

        if (cardType === WidgetTypes.NESTED_ITEM_CATEGORY_TYPE) {
            const parentTitle = String(inner.title ?? "");
            const parentCategoryId = inner.categoryId;
            if (!Array.isArray(inner.categories)) continue;
            for (const cat of inner.categories) {
                if (!Array.isArray(cat.itemCards)) continue;
                if (!cat.itemCards.some((ic) => getDishItemId(ic) === itemId)) continue;
                return {
                    collectionName: String(cat.title ?? parentTitle),
                    collectionId: String(cat.categoryId ?? parentCategoryId ?? ""),
                    parentType: String(inner.parentType ?? CROSS_SELL_MENU_DEFAULT_PARENT_TYPE),
                };
            }
        }
    }
    return null;
};
